import { useMutation } from '@tanstack/vue-query'
import type { QA } from '~/types'

export default () => {
  const authStore = useAuthStore()
  return useMutation({
    mutationFn: async (questions: QA[]) =>
      await $fetch<string>(`/api/user/${authStore.user!.id}/profile-answers`, {
        method: 'POST',
        body: JSON.stringify(questions),
        headers: {
          Authorization: `Bearer ${authStore.token}`,
        },
      }),
    onSuccess: () => {
      authStore.updateUser({
        ...authStore.user!,
        answeredQuestions: true,
      })
    },
  })
}
